import { Component, Vue, Prop } from 'vue-property-decorator'

import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'
import Loader from '@/components/Loader/index.vue'
import vSelect from 'vue-select'

import api from '@/helpers/fetch'

@Component({
	components: {
		Loader,
		vSelect,
		TypeableDatePortal,
	},
})
export default class CreateCollaborator extends Vue {
	@Prop({ required: true, type: Array }) existingUsers!: any
	@Prop({ default: 'Outros', type: String }) workRegime!: string
	loading = false
	sending = false

	form = {
		acquisition_period_start: '',
		acquisition_period_end: '',
		date_limit: '',
		user_id: '',
	}

	options = {
		users: [] as any[],
	}

	async mounted() {
		this.loading = true
		const res = await api.get('/api/users?name=locatelliadv.com.br')
		this.loading = false
		if (res.ok) {
			// filtra usuarios que ja possuem pelo menos um lançamento
			this.options.users = res.data.filter(
				(item) => !this.existingUsers.includes(item.id),
			)
		}
	}

	async send() {
		this.sending = true
		const res = await api.post('/api/vacations', {
			work_regime: this.workRegime,
			situation: 'A vencer',
			used_days: 0,
			balance: 0,
			type: '',
			usage_period_start: null,
			usage_period_end: null,
			allowance_period_start: null,
			allowance_period_end: null,
			...this.form,
		})
		this.sending = false

		if (res.ok) {
			this.$bvToast.toast('Colaborador inserido!', {
				title: 'Sucesso!',
				variant: 'success',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
			this.$emit('change')
			this.$bvModal.hide('create-collaborator')
		} else {
			this.$bvToast.toast('Não foi possível inserir colaborador', {
				title: 'Erro',
				variant: 'danger',
				solid: true,
				toaster: 'b-toaster-top-center',
			})
		}
	}

	resetForm() {
		this.form.acquisition_period_start = ''
		this.form.acquisition_period_end = ''
		this.form.date_limit = ''
		this.form.user_id = ''
	}

	handleCancel() {
		this.$emit('cancel')
		this.$bvModal.hide('create-collaborator')
	}
}
